import React from 'react';
import { FileText } from 'lucide-react';
import Header from './components/Header4';
import Footer from './components/Footer4';

const TermsAndConditions = () => {
    const sections = [
        {
            title: '1. Acceptance of Terms',
            content: 'By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.'
        },
        {
            title: '2. Use License',
            content: 'Permission is granted to temporarily download one copy of the materials on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not: modify or copy the materials; use the materials for any commercial purpose; attempt to decompile or reverse engineer any software contained on our website; remove any copyright or other proprietary notations from the materials.'
        },
        {
            title: '3. Product Information',
            content: 'We strive to provide accurate product descriptions and imagery. However, we do not warrant that product descriptions, pricing, or other content on this site is accurate, complete, reliable, current, or error-free. Colors shown on your screen may vary from actual product colors due to monitor settings and limitations. Handloom products may have minor variations which are characteristic of their handcrafted nature.'
        },
        {
            title: '4. Pricing & Payment',
            content: 'All prices are listed in Indian Rupees (\u20B9) and are inclusive of applicable taxes unless stated otherwise. We reserve the right to change prices at any time without prior notice. Payment must be made in full at the time of purchase. We accept credit/debit cards, UPI, net banking, and cash on delivery for select orders.'
        },
        {
            title: '5. Order Acceptance',
            content: 'We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in pricing or product information, or suspected fraudulent activity. In the event of cancellation, we will notify you and issue a full refund.'
        },
        {
            title: '6. Shipping & Delivery',
            content: 'Delivery timelines are estimates and may vary based on location and product type. Custom and bridal orders have separate timelines. We are not responsible for delays caused by shipping carriers, customs, or events beyond our control. Risk of loss passes to you upon delivery.'
        },
        {
            title: '7. Returns & Refunds',
            content: 'Returns are accepted within 7 days of delivery for unused items in original condition with all tags attached. Custom-made, bridal, and sale items are non-returnable. Refunds will be processed within 7-10 business days of receiving the returned item. Original shipping charges are non-refundable.'
        },
        {
            title: '8. Intellectual Property',
            content: 'All content on this website, including text, graphics, logos, images, and software, is the property of NEELA and is protected by intellectual property laws. Unauthorized use of any materials may violate copyright, trademark, and other laws.'
        },
        {
            title: '9. Limitation of Liability',
            content: 'In no event shall NEELA or its suppliers be liable for any damages arising out of the use or inability to use the materials on this website. This limitation applies even if NEELA has been notified of the possibility of such damages.'
        },
        {
            title: '10. Governing Law',
            content: 'These terms are governed by the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.'
        },
    ];

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <main className="pt-20 md:pt-24">
                {/* Hero */}
                <div className="bg-[#F0F7FA] py-10 md:py-16 px-4 text-center">
                    <div className="w-12 h-12 bg-[#1B4965] rounded-full flex items-center justify-center mx-auto mb-4">
                        <FileText className="w-6 h-6 text-white" />
                    </div>
                    <h1 className="text-3xl md:text-4xl font-semibold text-[#1B4965] mb-3">Terms & Conditions</h1>
                    <p className="text-sm text-[#6B7280]">Last updated: March 2026</p>
                </div>

                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                    <div className="space-y-8">
                        {sections.map((section, i) => (
                            <div key={i}>
                                <h2 className="text-base font-semibold text-[#1B4965] mb-3">{section.title}</h2>
                                <p className="text-sm text-[#6B7280] leading-relaxed">{section.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default TermsAndConditions;
